import { X } from 'lucide-react';

export default function Dialog({ open, title, description, onClose, children, size = 'medium', footer, className = '' }) {
  if (!open) return null;
  return (
    <div className={`dialog-backdrop ${className}`.trim()} role="presentation" onPointerDown={(event) => event.target === event.currentTarget && onClose?.()}>
      <section className={`dialog dialog--${size}`} role="dialog" aria-modal="true" aria-labelledby="dialog-title">
        <header className="dialog__header">
          <div>
            <h2 id="dialog-title">{title}</h2>
            {description && <p>{description}</p>}
          </div>
          <button type="button" className="icon-button" onClick={onClose} aria-label="关闭"><X size={20} /></button>
        </header>
        <div className="dialog__body">{children}</div>
        {footer && <footer className="dialog__footer">{footer}</footer>}
      </section>
    </div>
  );
}
